import styled from 'styled-components';

export const Container = styled.header`
  grid-area: HD;
  background: ${(props) => props.theme.backgroundHeader};
  height: 3.75rem;

  align-self: center;
  border-radius: 0.75rem;
  padding: 0.5rem 1.5rem;

  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    height: 70%;
    width: 1px;
    background: ${(props) => props.theme.headerDivider};
    margin: 0 1rem;
  }
  p {
    color: ${(props) => props.theme.textWhite};
  }
`;

export const Section = styled.header`
  /* grid-area: HD; */
  /* background: ${(props) => props.theme.backgroundHeader}; */
  height: 3.75rem;

  /* align-self: center;
  border-radius: 0.75rem;
  padding: 0.5rem 1.5rem; */

  display: flex;
  align-items: center;
  justify-content: flex-end;

  span {
    height: 70%;
    width: 1px;
    background: ${(props) => props.theme.headerDivider};
    margin: 0 1rem;
  }

`;
